import React, { useState } from 'react';
import styled from 'styled-components';
import { IoIosMail } from "react-icons/io";
import axios from 'axios';

const Contactus = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    contactNumber: '',
    message: ''
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const formHandling = async (e) => {
    e.preventDefault();

    // Simple email validation
    if (!formData.email.includes('@')) {
      alert("Please enter a valid email");
      return;
    }

    try {
      setLoading(true);

      const response = await axios.post(
        'https://api.bakpoket.com/api/Contact/Submit',
        formData,
        {
          headers: {
            'Content-Type': 'application/json'
          }
        }
      );

      console.log('Success:', response.data);

      alert('Message sent successfully!');

      // Reset form
      setFormData({
        name: '',
        email: '',
        contactNumber: '',
        message: ''
      });

    } catch (error) {
      console.error('Error:', error.response?.data || error.message);
      alert('Message send failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Wrapper>
      <h2>Contact Us</h2>

      <div className='content-wrapper'>

        <form className='contact-form' onSubmit={formHandling}>
          <input
            name="name"
            placeholder='Your Name'
            value={formData.name}
            onChange={handleChange}
            required
          />

          <input
            name="email"
            type="email"
            placeholder='Your Email Address'
            value={formData.email}
            onChange={handleChange}
            required
          />

          <input
            name="contactNumber"
            placeholder='Contact Number'
            value={formData.contactNumber}
            onChange={handleChange}
            required
          />

          <textarea
            name="message"
            placeholder='Type your Message Here...'
            value={formData.message}
            onChange={handleChange}
            required
          />

          <button type='submit' disabled={loading}>
            {loading ? "Sending..." : "Send Message"}
          </button>
        </form>

        <div className='main-card'>
          <div className='sub-card1 first-card'>
            <IoIosMail className='icons' />
            <h3>General Enquiries:</h3>
            <a href='mailto:info@bakpoket.com'>info@bakpoket.com</a>
          </div>
        </div>

      </div>
    </Wrapper>
  );
};

const Wrapper = styled.section`
  margin: 40px auto;
  text-align: center;
  max-width: 1080px;
  padding: 0 20px;

  h2 {
    margin-bottom: 30px;
    color: #2a4157;
  }

  .content-wrapper {
    display: flex;
    justify-content: center;
    gap: 40px;
    flex-wrap: wrap;
  }

  .contact-form {
    flex: 1;
    min-width: 300px;
    display: flex;
    flex-direction: column;
    gap: 15px;
    padding: 30px;
    border: 1px solid #ddd;
    border-radius: 10px;
  }

  .contact-form input,
  .contact-form textarea {
    padding: 12px;
    border: 1px solid #ccc;
    border-radius: 6px;
  }

  .contact-form button {
    padding: 12px;
    background-color: #ef4766;
    color: white;
    border: none;
    border-radius: 6px;
    cursor: pointer;
  }

  .contact-form button:disabled {
    background-color: gray;
    cursor: not-allowed;
  }

  .sub-card1 {
    padding: 30px;
    border: 1px solid #ddd;
    border-left: 4px solid #ef4766;
    border-radius: 10px;
  }

  .icons {
    font-size: 2rem;
    color: #ef4766;
  }
`;

export default Contactus;